import { render, staticRenderFns } from "./StepFiveIllustration.vue?vue&type=template&id=6d46f925&"
import script from "./StepFiveIllustration.vue?vue&type=script&lang=js&"
export * from "./StepFiveIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports